import { Button } from "@/components/ui/button";
import { Save, Mail } from "lucide-react";
import { BTN } from "@/components/common/btn";
import { WOCompleteButton } from "./WOCompleteButton";

// Action buttons shown when the WO is in `scheduled` status —
// technician's gone to site or is en route, so the focus is on
// completing rather than re-approving.
export function WOScheduledActions({
  handleSave, openEmailDialog,
  confirmWOComplete, setConfirmWOComplete,
}) {
  return (
    <>
      <Button size="sm" className={BTN.write} onClick={() => handleSave()} data-testid="btn-save-wo">
        <Save className="w-3.5 h-3.5 mr-1" /> Save
      </Button>
      <Button size="sm" className={BTN.internal} onClick={() => openEmailDialog("signed")} data-testid="btn-resend-signed">
        <Mail className="w-3.5 h-3.5 mr-1" /> Email signed WO
      </Button>
      <WOCompleteButton
        confirmWOComplete={confirmWOComplete}
        setConfirmWOComplete={setConfirmWOComplete}
        onConfirm={() => handleSave("completed")}
      />
    </>
  );
}
